import { account, loise } from './config-export.js';

const configs = {
    development: {
        account: { client: account.clientDevelopment, server: account.serverDevelopment },
        loise: { client: loise.clientDevelopment, server: loise.serverDevelopment },
    },
    production: {
        account: { client: account.clientProduction, server: account.serverProduction },
        loise: { client: loise.clientProduction, server: loise.serverProduction },
    },
};

// Admin-only per-key descriptions (env-independent). Assembled like `configs`.
const descriptions = {
    account: { client: account.clientDescription, server: account.serverDescription },
    loise: { client: loise.clientDescription, server: loise.serverDescription },
};

// 키 정렬 JSON (항상 같은 문자열 보장)
function stableStringify(obj) {
    const seen = new WeakSet();
    const sort = (v) => {
        if (v && typeof v === 'object') {
            if (seen.has(v)) return v;
            seen.add(v);
            if (Array.isArray(v)) return v.map(sort);
            const out = {};
            for (const k of Object.keys(v).sort()) out[k] = sort(v[k]);
            return out;
        }
        return v;
    };
    return JSON.stringify(sort(obj));
}

export { configs, descriptions, stableStringify };
